import type { Template } from "@/types";

export const PO_05_H5_V0: Template[] = [
{
    id: "po-05-h5v0-01",
    name: "PO 01 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_01.png",
    size: [1136, 854],
    style: {},
        slots: [      
            { id: "1", x: 44, y: 243, width: 236, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 431, width: 236, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 243, width: 236, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 288, y: 431, width: 236, height: 179, rotation: 0, imageRotation: 0 },
            { id: "5", x: 613, y: 243, width: 480, height: 367, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h5v0-02",
    name: "PO 02 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_02.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 0, y: 212, width: 278, height: 212, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 432, width: 278, height: 211, rotation: 0, imageRotation: 0 },
        { id: "3", x: 286, y: 212, width: 278, height: 212, rotation: 0, imageRotation: 0 },
        { id: "4", x: 286, y: 432, width: 278, height: 211, rotation: 0, imageRotation: 0 },
        { id: "5", x: 572, y: 212, width: 564, height: 431, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-03",
    name: "PO 03 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_03.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 0, y: 212, width: 279, height: 212, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 432, width: 279, height: 211, rotation: 0, imageRotation: 0 },
        { id: "3", x: 287, y: 212, width: 562, height: 431, rotation: 0, imageRotation: 0 },
        { id: "4", x: 857, y: 212, width: 279, height: 212, rotation: 0, imageRotation: 0 },
        { id: "5", x: 857, y: 432, width: 279, height: 211, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-04",
    name: "PO 04 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 45, y: 182, width: 480, height: 367, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 45, y: 557, width: 155, height: 117, rotation: 0, imageRotation: 0 },
        { id: "3", x: 208, y: 557, width: 155, height: 117, rotation: 0, imageRotation: 0 },
        { id: "4", x: 371, y: 557, width: 154, height: 117, rotation: 0, imageRotation: 0 },
        { id: "5", x: 613, y: 243, width: 480, height: 367, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-05-h5v0-05",
    name: "PO 05 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 211, width: 568, height: 433, rotation: 0, imageRotation: 0 },
        { id: "2", x: 674, y: 88, width: 356, height: 267, rotation: 0, imageRotation: 0 },
        { id: "3", x: 674, y: 363, width: 356, height: 266, rotation: 0, imageRotation: 0 },
        { id: "4", x: 674, y: 637, width: 174, height: 130, rotation: 0, imageRotation: 0 },
        { id: "5", x: 856, y: 637, width: 174, height: 130, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-06",
    name: "PO 06 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_06.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 172, y: 150, width: 236, height: 180, rotation: 0, imageRotation: 0 },
        { id: "2", x: 172, y: 525, width: 236, height: 179, rotation: 0, imageRotation: 0 },
        { id: "3", x: 48, y: 337, width: 236, height: 181, rotation: 0, imageRotation: 0 },
        { id: "4", x: 292, y: 337, width: 235, height: 181, rotation: 0, imageRotation: 0 },
        { id: "5", x: 613, y: 243, width: 480, height: 367, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-07",
    name: "PO 07 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 131, y: 84, width: 306, height: 224, rotation: 0, imageRotation: 0 },
        { id: "2", x: 131, y: 316, width: 306, height: 223, rotation: 0, imageRotation: 0 },
        { id: "3", x: 131, y: 547, width: 306, height: 223, rotation: 0, imageRotation: 0 },
        { id: "4", x: 631, y: 84, width: 443, height: 339, rotation: 0, imageRotation: 0 },
        { id: "5", x: 631, y: 431, width: 443, height: 339, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-08",
    name: "PO 08 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 36, y: 239, width: 496, height: 378, rotation: 0, imageRotation: 0 },
        { id: "2", x: 674, y: 87, width: 356, height: 268, rotation: 0, imageRotation: 0 },
        { id: "3", x: 674, y: 500, width: 356, height: 268, rotation: 0, imageRotation: 0 },
        { id: "4", x: 674, y: 363, width: 174, height: 129, rotation: 0, imageRotation: 0 },
        { id: "5", x: 856, y: 363, width: 173, height: 129, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-09",
    name: "PO 09 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_09.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 64, y: 227, width: 246, height: 196, rotation: 0, imageRotation: 0 },
        { id: "2", x: 64, y: 431, width: 246, height: 196, rotation: 0, imageRotation: 0 },
        { id: "3", x: 318, y: 227, width: 501, height: 400, rotation: 0, imageRotation: 0 },
        { id: "4", x: 827, y: 227, width: 245, height: 196, rotation: 0, imageRotation: 0 },
        { id: "5", x: 827, y: 431, width: 245, height: 196, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h5v0-10",
    name: "PO 10 - H5V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h5_v0_10.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 64, y: 125, width: 197, height: 145, rotation: 0, imageRotation: 0 },
        { id: "2", x: 64, y: 278, width: 197, height: 145, rotation: 0, imageRotation: 0 },
        { id: "3", x: 64, y: 431, width: 197, height: 145, rotation: 0, imageRotation: 0 },
        { id: "4", x: 64, y: 584, width: 197, height: 145, rotation: 0, imageRotation: 0 },
        { id: "5", x: 269, y: 125, width: 802, height: 604, rotation: 0, imageRotation: 0 }
    ],
}
];